import ConfirmTemplate from '~plugins/confirm/ConfirmTemplate.vue'
import { i18n } from '~src/i18n'
import { getVuetifyInstance } from '../vuetify'

export default {
  install(Vue) {
    const ConfirmConstructor = Vue.extend(ConfirmTemplate)
    let confirmInstance = null

    function destroyInstance() {
      confirmInstance.$destroy()
      if (confirmInstance.$el && confirmInstance.$el.parentNode) {
        confirmInstance.$el.parentNode.removeChild(confirmInstance.$el)
      }
      confirmInstance = null
    }

    Vue.confirm = Vue.prototype.$confirm = config => {
      return new Promise(resolve => {
        if (confirmInstance) return
        const vuetify = getVuetifyInstance()

        confirmInstance = new ConfirmConstructor({
          i18n,
          vuetify,
          propsData: {
            width: config.width,
            title: config.title,
            titleIcon: config.titleIcon,
            message: config.message,
            confirmText: config.confirmText,
            confirmIcon: config.confirmIcon,
            confirmColor: config.confirmColor,
            cancelIcon: config.cancelIcon,
            cancelFlat: config.cancelFlat,
            cancelColor: config.cancelColor,
            cancelText: config.cancelText,
            typeToConfirm: config.typeToConfirm,
            textToCompare: config.textToCompare,
            closeable: config.closeable,
            hideCancel: config.hideCancel,
            dialogClass: config.dialogClass
          }
        })
        confirmInstance.$mount()
        confirmInstance.$on('confirm', () => {
          destroyInstance()
          resolve(true)
        })

        confirmInstance.$on('cancel', () => {
          destroyInstance()
          resolve(false)
        })

        confirmInstance.$on('close', () => {
          destroyInstance()
          resolve()
        })

        confirmInstance.open = true
        document.body.appendChild(confirmInstance.$el)
      })
    }
  }
}
